var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { translate, useModal, useToastService } from '@lucidlink/uicore';
import { InviteMembersByEmailModal } from '#components';
import { MODAL_IDS } from '#constants';
import { useWorkspaceMarkOnboardingAsCompleted } from '#query-hooks';
import { ACTIVE_SESSION_KEY } from '../../workspaceOnboarding.constants';
const SILENT_ONBOARDING_WIDGETS = process.env.SILENT_ONBOARDING_WIDGETS;
export const useOnboarding = ({ filespacesData, hasMembers, workspaceData, }) => {
    _react_refresh_temp_1();
    // Open the Onboarding widget on the initial load for the session
    const isInActiveSession = useMemo(() => Boolean(sessionStorage.getItem(ACTIVE_SESSION_KEY)), []);
    const { filespaceId = filespacesData.at(0)?.id } = useParams();
    const filespaceData = filespacesData.find((filespace) => filespace.id === filespaceId);
    const { addToast } = useToastService();
    const [shouldCloseFloatingBox, setShouldCloseFloatingBox] = useState(false);
    const [hasChange, setHasChange] = useState(false);
    const { closeModal: closeInviteModal, openModal: openInviteModal } = useModal({
        modalId: MODAL_IDS.InviteMembers,
        closeOnUnmount: true,
    });
    const openInviteMembers = useCallback(() => {
        openInviteModal({
            content: (_jsx(InviteMembersByEmailModal, { closeModal: closeInviteModal, workspaceData: workspaceData })),
        });
    }, [closeInviteModal, openInviteModal, workspaceData]);
    const { mutation: { mutate: onFinishOnboarding }, } = useWorkspaceMarkOnboardingAsCompleted(workspaceData.id, {
        onError: () => {
            addToast({
                'data-testid': 'mark-onboarding-as-finished-error',
                kind: 'negative',
                content: {
                    message: translate('Failed to mark onboarding process as finished.'),
                },
            });
        },
    });
    const closeOnboarding = useCallback(() => {
        setShouldCloseFloatingBox(true);
    }, []);
    const hasFilespace = Boolean(filespacesData.length);
    const completedSteps = useMemo(() => {
        // Number(false) = 0
        // Number(true) = 1
        // Using 'as' to make TS happy
        return (Number(hasFilespace) +
            Number(hasMembers) +
            Number(workspaceData.hasDataBeenUploadedToAnyFilespace));
    }, [
        hasFilespace,
        hasMembers,
        workspaceData.hasDataBeenUploadedToAnyFilespace,
    ]);
    const prevCompletedStepsRef = useRef(undefined);
    const shouldOpenInitially = useMemo(() => {
        return (SILENT_ONBOARDING_WIDGETS !== 'true' &&
            !isInActiveSession &&
            completedSteps < 3);
    }, [completedSteps, isInActiveSession]);
    useEffect(() => {
        if (prevCompletedStepsRef.current !== completedSteps) {
            prevCompletedStepsRef.current = completedSteps;
            setHasChange(true);
        }
    }, [completedSteps]);
    const trackFloatingBoxState = useCallback((state) => {
        if (state) {
            // Make shure the widget opens only on the initial load for the session
            sessionStorage.setItem(ACTIVE_SESSION_KEY, 'true');
            setShouldCloseFloatingBox(false);
            setHasChange(false);
        }
    }, []);
    return {
        closeOnboarding,
        completedSteps,
        filespaceData,
        hasChange,
        hasFiles: Boolean(workspaceData.hasDataBeenUploadedToAnyFilespace),
        hasFilespace: Boolean(filespaceId),
        hasMembers,
        onFinishOnboarding,
        openInviteMembers,
        shouldCloseFloatingBox,
        shouldOpenInitially,
        trackFloatingBoxState,
    };
};
_react_refresh_temp_1(useOnboarding, "tKcAJGsKH3Oq3H7k9qpw6Fk6Wfg=", false, () => [useParams, useToastService, useModal, useWorkspaceMarkOnboardingAsCompleted]);
